export var C;
(function (C) {
    function create(s) {
        return c(s);
    }
    C.create = create;
    function hbox(...content) {
        return create("<div style='display: flex; justify-content: center'></div>").append(...content);
    }
    C.hbox = hbox;
    function hgrid(...content) {
        return cls("nisl-hgrid").append(...content.map(e => typeof e == "string" ? div(e) : e));
    }
    C.hgrid = hgrid;
    function hboxl(...content) {
        return create("<div style='display: flex'></div>").append(...content);
    }
    C.hboxl = hboxl;
    function btnrow(...buttons) {
        return create("<div style='display: flex' class='ctr-button-container'></div>").append(...buttons);
    }
    C.btnrow = btnrow;
    function hboxc(...content) {
        return create("<div style='display: flex; justify-content: center'></div>").append(...content);
    }
    C.hboxc = hboxc;
    function vbox(...content) {
        return create("<div></div>").append(...content);
    }
    C.vbox = vbox;
    function centered(...content) {
        return create("<div style='text-align: center'></div>").append(...content);
    }
    C.centered = centered;
    function spacer() {
        return create("<div style='flex-grow: 1'></div>");
    }
    C.spacer = spacer;
    function span(text = "") {
        return create("<span></span>").text(text);
    }
    C.span = span;
    function italic(text = "") {
        return create("<span style='font-style: italic'></span>").text(text);
    }
    C.italic = italic;
    function bold(text) {
        return create("<span style='font-weight: bold'></span>").text(text);
    }
    C.bold = bold;
    function space() {
        return create("<span>&nbsp;</span>");
    }
    C.space = space;
    function h(level, text) {
        return create(`<h${level}>${text}</h${level}>`);
    }
    C.h = h;
    function img(src) {
        return create(`<img>`)
            .setAttribute("src", src);
    }
    C.img = img;
    function inlineimg(src) {
        return img(src)
            .addClass("text-icon");
    }
    C.inlineimg = inlineimg;
    function div(...content) {
        return c().append(...content);
    }
    C.div = div;
    function par(...content) {
        return c("<p>").append(...content);
    }
    C.par = par;
    function text_link(content, handler) {
        return c("<span class='nisl-textlink'>").text(content).on("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            handler();
        });
    }
    C.text_link = text_link;
    function link(href) {
        return c("<a target='_blank'></a>").setAttribute("href", href).tooltip(href);
    }
    C.link = link;
    function npc(name, clickable = false) {
        return c("<span class='nisl-npc'></span>").toggleClass("ctr-clickable", clickable).text(name);
    }
    C.npc = npc;
    function staticentity(name, clickable = false) {
        if (!name)
            debugger;
        return c("<span class='nisl-entity'></span>").toggleClass("ctr-clickable", clickable).text(name);
    }
    C.staticentity = staticentity;
    function item(name) {
        const is_none = name.startsWith("Nothing") || name.startsWith("No ");
        if (is_none) {
            return create("<span class='nisl-noitem'></span>").text(name);
        }
        else {
            return create("<span class='nisl-item'></span>").text(name);
        }
    }
    C.item = item;
    function entity(entity) {
        switch (entity.kind) {
            case "npc":
                return npc(entity.name);
            case "static":
                return staticentity(entity.name);
            case "item":
                return item(entity.name);
        }
    }
    C.entity = entity;
    function cls(c) {
        return C.div().addClass(c);
    }
    C.cls = cls;
    function mediaContainer(...children) {
        return cls("ctr-media-container").append(...children);
    }
    C.mediaContainer = mediaContainer;
})(C || (C = {}));
